import { defineStore } from 'pinia'
import { ref } from 'vue'
import { type Message, MessagesApi } from '@/api-swagger'

export const useMessageStore = defineStore('message', () => {
  const messages = ref<Message[]>([])
  const loading = ref(false)
  const api = new MessagesApi()

  const getMessagesByPartnerId = async (partnerId: number) => {
    loading.value = true
    messages.value = []
    try {
      messages.value = (await api.getPartnerMessages({ partnerId })) || []
      messages.value.sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime())
      messages.value.forEach((message) => {
        message.body = message.body.replace('<span>Appeler</span> terminée', 'To Do terminé')
      })
      return messages.value
    } catch (error) {
      console.error(error)
    } finally {
      loading.value = false
    }
  }

  return {
    messages,
    loading,
    getMessagesByPartnerId,
  }
})
